@file:OptIn(InternalResourceApi::class)

package fr.frux.feature.treelist.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/fr.frux.feature.treelist.resources/"

@delegate:ResourceContentHash(854_815_724)
internal val Res.string.treelist_empty_cta: StringResource by lazy {
      StringResource("string:treelist_empty_cta", "treelist_empty_cta", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 50),
      ))
    }

@delegate:ResourceContentHash(345_292_927)
internal val Res.string.treelist_empty_message: StringResource by lazy {
      StringResource("string:treelist_empty_message", "treelist_empty_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 61, 106),
      ))
    }

@delegate:ResourceContentHash(-1_124_987_576)
internal val Res.string.treelist_empty_title: StringResource by lazy {
      StringResource("string:treelist_empty_title", "treelist_empty_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 168, 76),
      ))
    }

@delegate:ResourceContentHash(-115_275_660)
internal val Res.string.treelist_title: StringResource by lazy {
      StringResource("string:treelist_title", "treelist_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 245, 42),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("treelist_empty_cta", Res.string.treelist_empty_cta)
  map.put("treelist_empty_message", Res.string.treelist_empty_message)
  map.put("treelist_empty_title", Res.string.treelist_empty_title)
  map.put("treelist_title", Res.string.treelist_title)
}
